/**
 * Created by Bart Decorte
 * Date: 19/12/2018
 * Time: 15:14
 */
import Page from '../Page';
import Util from '../../utils/Util';
import Dropzone from '../../components/uploads/Dropzone';
import toasts from '../../toasts/ToastManager';

class EntriesAssets extends Page {
  constructor(dropzoneParams = {}) {
    super();
    this.dropzone = new Dropzone(this.dropzoneEl(), dropzoneParams);
    this.bindListeners();
  }

  bindListeners() {
    this.dropzone.on('failure', () => this.lDropzoneFailed());
    this.dropzone.on('success', data => this.lDropzoneSucceeded(data));
  }

  lDropzoneFailed() {
    toasts().danger(`File failed to upload`);
  }

  lDropzoneSucceeded(result) {
    this.submitForm();
  }

  submitForm() {
    document.createElement('form').submit.call(this.formEl());
  }

  propagateToCkEditor(url) {
    window.opener.CKEDITOR.tools.callFunction(
      Util.getUrlParameter('CKEditorFuncNum'),
      url
    );
    window.close();
  }

  formEl() {
    return this.rootEl.querySelector('.js-asset-upload');
  }

  inputPathEl() {
    return this.rootEl.querySelector('.js-old-path');
  }

  inputNameEl() {
    return this.rootEl.querySelector('.js-old-name');
  }

  inputMimeEl() {
    return this.rootEl.querySelector('.js-old-mime');
  }

  dropzoneEl() {
    return this.rootEl.querySelector('.js-dropzone-wrap');
  }
}

export default EntriesAssets;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Entries/EntriesAssets.js